import React, {useContext} from "react"
import Link from "../Links"
import {buildClassList} from "../helpers/utilities"
import {CONTAINER_LG} from "../helpers/constants"
import {TOGGLE_SEARCH, TOGGLE_MENU} from "../context/types"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faAngleUp, faAngleDown} from "@fortawesome/free-solid-svg-icons"
import SearchField from "../SearchField"
import SiteContext from "../context/SiteContext"

const getList = (list) => {
  return (
    list.map((item) => {
      return (
      <li key={item.key} className={item.langCode}>
        <Link
          langCode={item.langCode}
          href={item.href} 
          external={item.external}
          className={buildClassList([
            "languageLink text-blue-500 pt-4 pb-3 px-4 block text-left font-bold leading-none",
            "hover:text-blue-600 focus:text-blue-600"
          ])}
          >
          { item.text }
        </Link>
      </li>)
    })
  )
}

const HeaderNavItem = ({ 
  children, 
  href, list, type, 
  external,
  className, icon, target, 
  toggleText,
  languageButton,
  ...props 
}) => {

  const {site, width, toggleSearch, menuState, toggleMenu, toggleLang, langState} = useContext(SiteContext)

  const angleIcon = !langState 
    ? <FontAwesomeIcon icon={faAngleDown} className="top-neg-1 ml-1" height={"1em"} width={"1em"} focusable="false"/> 
    : <FontAwesomeIcon icon={faAngleUp} className="top-neg-1 ml-1" height={"1em"} width={"1em"} focusable="false"/>

  if (type === "link" && href.length) {
    return (
      <li className="headerNavItem border-r" {...props}>
        <Link className="px-3 py-1 lg:px-5 leading-none table-cell lg:hover:underline lg:text-sm"
          external={external}
          icon={icon}
          href={href}>
          {children}
        </Link>
      </li>
    )
  } else if (type === "languageSwitcher" && list.length) {
    return (
      <li className="headerNavItem border-r" {...props}>
        <button 
          id={languageButton ? languageButton : "languageButton"}
          className="flex px-3 lg:px-5 lg:py-1 w-full py-3 block leading-none lg:hover:underline lg:text-sm" 
          onClick={() => toggleLang()}
          aria-expanded={langState}
        >
          {children}{angleIcon}
        </button>
        <ul className={buildClassList([
          "dropdownMenu bg-gray-400 ",
          "lg:absolute lg:z-50 lg:w-48 lg:mt-2 lg:border-gray-400 lg:rounded-sm lg:shadow", 
          langState ? "visible" : "hidden"
        ])}>
          { list && getList(list) }
        </ul>
      </li>
    )
  } else if (type === "toggleButton" && target) {

    return (
      <>
        {target === TOGGLE_SEARCH && 
        <li id="toggleSearch" className="headerNavItem border-r">
        <a
          role="button"
          href={site.search.show ? "#header-search" : "#" } 
          aria-expanded={site.search.show}
          className="toggleSearch uppercase flex px-3 py-1 lg:px-5 leading-none lg:hover:underline lg:text-sm" 
          onClick={(e) => toggleSearch(e)}
        >
          {children}
        </a>
        <div className={buildClassList([
          "bg-blue-600 h-16 w-full",
          site.search.show && width < CONTAINER_LG 
            ? "absolute left-0 right-0" 
            : "block hidden"
        ])}
        style={{top: "55px"}}>
          <div className="container">
            <SearchField
              className={buildClassList(["mt-0 w-full"])}
              id="header-search"
              formID="headerSearchForm"
              buttonId="headerSearchButton"
              label={site.search.label}
              btnLabel={site.search.btnLabel}
              placeholder={site.search.placeholder}
              action={site.search.action}
              external={site.search.external}
              style={{maxHeight: "24px", lineHeight: "22px"}}
            />
          </div>
        </div>
        </li>
        }
        {target === TOGGLE_MENU && 
        <li className="headerNavItem border-r"> 
          <a 
            href="#toggleMenu"
            role="button"
            aria-expanded={menuState}
            className={buildClassList([
              "toggleMenu uppercase flex px-3 py-1 lg:px-5 leading-none lg:hover:underline",
              children === "Menu" ? "spaced" : ""
            ])} 
            onClick={(e) => toggleMenu(e)}
            style={{transition: "none"}}
            >
              {children}
          </a>
        </li>
        }
      </>
    )
  } else {
    return (
      <li className="navItem" {...props}>
        {children}
      </li>
    )
  }
}

export default HeaderNavItem